import { createAction, createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

export const getAllProjects = createAction('projects/getAllProjects');
// Slices

const projectsSlice = createSlice({
  name: 'projects',
  initialState: initialStore.projects,
  reducers: {
    getProjectsData: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setProjectsData: (state, { payload }) => {
      state.isLoading = false;
      state.allProjects = payload;
    },
    getProjectsFail: (state) => {
      state.isLoading = false;
    }
  }
});

export const { getProjectsData, setProjectsData, getProjectsFail } =
  projectsSlice.actions;

export const { reducer } = projectsSlice;

// Selectors
export const getAllProjectsSelector = (state: IState) =>
  state && state.projects.allProjects;

export const getProjectsLoadingSelector = (state: IState) =>
  state && state.projects.isLoading;
